export const videoJsOptions = {
  id: 'VideoPlayer',
  // id: 'my-player',
  autoplay: false,
  controls: true,
  loop: false,
  preload: 'auto',
  sources: [],
  playbackRates: [0.5, 1, 1.5, 2, 5],
  errorDisplay: false,
  controlBar: {
    volumePanel: { inline: false },
  },
  liveui: true,
};

export const clipperVideoJsOptions = {
  id: 'my-player',
};

export const waveFormJsOptions = {
  id: 'AudioPlayer',
  plugins: {
    wavesurfer: {
      backend: 'MediaElement',
      displayMilliseconds: false,
      waveColor: '#C0C0C0',
      progressColor: '#808080',
      cursorColor: 'transparent',
      hideScrollbar: true,
    },
  },
};
